import { Outlet, useLocation, useOutletContext } from "react-router-dom";
import { Box, LinearProgress, Stack, Tabs } from "@mui/material";
import { Fragment } from "react";
import { AccountTreeOutlined } from "@mui/icons-material";
import HistoryToggleOffOutlinedIcon from "@mui/icons-material/HistoryToggleOffOutlined";
import { useDidMount } from "rooks";
import { useDispatch } from "react-redux";
import { AutomationsHeaderTab } from "./components/AutomationsHeaderTab";
import { OffHoursCreateButton } from "./components/OffHoursCreateButton";
import { OutletContextType } from "../../../layout/MainLayout";
import { pageHeaderHeight } from "../../common/PageHeader";
import { NavigationExpander } from "../../common/navigation-expander/NavigationExpander";
import { useGetUsersMeOffHoursSchedulesQuery } from "@/services/cloudchipr.api";
import { getWorkflowsThunk } from "@/store/automations/thunks/wokrflows/getWorkflowsThunk";
import { useAppSelector } from "@/store/hooks";
import { workflowsDataLoadingSelector } from "@/store/automations/selectros/workflow/list-data/workflowsDataLoadingSelector";
import { originalDataCountSelector } from "@/store/automations/selectros/workflow/list-data/originalDataCountSelector";

export const AutomationsOutlet = () => {
  const dispatch = useDispatch();
  const outletContext = useOutletContext<OutletContextType>();
  const location = useLocation();

  const isOffHoursPage = location.pathname.includes("off-hours");
  const value = isOffHoursPage ? "off-hours" : "workflow";

  const { data, isLoading: offHoursLoading } =
    useGetUsersMeOffHoursSchedulesQuery({});
  const workflowsLoading = useAppSelector(workflowsDataLoadingSelector);

  const workflowsCount = useAppSelector(originalDataCountSelector);
  const offHoursCount = data?.length ?? 0;

  useDidMount(() => {
    dispatch(getWorkflowsThunk());
  });

  return (
    <Fragment>
      <Stack
        position="sticky"
        top={0}
        zIndex="appBar"
        bgcolor="white"
        height={pageHeaderHeight}
        borderBottom={1}
        direction="row"
        borderColor="grey.300"
        alignItems="center"
        justifyContent="space-between"
        px={1}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <NavigationExpander />

          <Tabs value={value}>
            <AutomationsHeaderTab
              value="workflow"
              title="Workflows"
              count={workflowsCount}
              active={!isOffHoursPage}
              icon={AccountTreeOutlined}
              to="/automations/workflow"
            />

            <AutomationsHeaderTab
              value="off-hours"
              title="Off Hours"
              count={offHoursCount}
              active={isOffHoursPage}
              icon={HistoryToggleOffOutlinedIcon}
              to="/automations/off-hours"
            />
          </Tabs>
        </Stack>

        {!!data?.length && isOffHoursPage && <OffHoursCreateButton />}

        {(offHoursLoading || workflowsLoading) && (
          <Box position="absolute" bottom={0} left={0} right={0}>
            <LinearProgress />
          </Box>
        )}
      </Stack>
      <Outlet context={outletContext} />
    </Fragment>
  );
};
